import "../../css/master.css";
import "../../css/app.css";
import "../../css/custom.css";
import MainComponent from "./main_component";

function HandlePersonalInfo() {

    return (
        <MainComponent />
    );
}
export default HandlePersonalInfo;